import React from 'react';
import './index.css';

function HeaderGauge (props) {

    return (
        <div className={`header-gauge${props.overQuota ? ' over-quota' : ''}`}>
            <a href='/dashboard'>
                <p>{props.value} {props.label}</p>
                <div className="gauge__fill" style={{backgroundColor: props.overQuota ? 'inherit' : props.color, width: props.value * 100 / (props.max || 100)}}/>
                {
                    props.details &&
                    <div className="header-gauge__details">
                        <p className="mb-0">{props.details}</p>
                    </div>
                }
            </a>
        </div>
    )

}

export default HeaderGauge;